import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { createJAV } from '@/repository/jav';
import { JAV } from '@/model/jav';
import { useStore } from 'vuex';
import { HttpStatusCode } from 'axios';
import JAVInformation from '@/components/disposable/JAVInformation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateJAVView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isLoading = ref(false);
const jav = ref<JAV>(initialize());

function initialize(): JAV {
	return {
		code: '',
		title: '',
		coverImageURL: '',
		link: '',
		actresses: [],
		genres: [],
		isFavorite: false
	};
}

async function saveJAV(isRedirect: boolean, data: JAV) {
	jav.value = data;
	try {
		isLoading.value = true;
		if (jav.value) {
			// DISABLED UPLOAD
			const res = await createJAV(jav.value);
			if (res.status === HttpStatusCode.Ok) {
				store.dispatch('alert', { type: 'success', message: 'create new jav successfully!' });
				if (isRedirect) {
					isLoading.value = false;
					await router.push({ name: 'JAV' });
					return;
				}
				jav.value = initialize();
			} else if (res.status === HttpStatusCode.BadRequest) {
				throw res.error?.error;
			} else if (res.status === HttpStatusCode.Conflict) {
				throw Error('this jav is already exists!');
			}
		}
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(JAVInformation, {
      jav: jav.value,
      "is-loading": isLoading.value,
      onReset: _cache[0] || (_cache[0] = () => (jav.value = initialize())),
      onSubmit: saveJAV,
      mode: "CREATE"
    }, null, 8, ["jav", "is-loading"])
  ]))
}
}

})